export default "__VITE_ASSET__w3MB20vQ__"